window.addEventListener("DOMContentLoaded", function () {
 

  const updateText = (key) => {
    if (
      document.querySelector(
        "#product-grid .collection_img_with_text .text-wrap ." + key
      )
    ) {
      document
        .querySelectorAll(
          "#product-grid .collection_img_with_text .text-wrap ." + key
        )
        .forEach((ele) => {
          ele.classList.add("active");
        });

      document
        .querySelectorAll(
          "#product-grid .collection_img_with_text .text-wrap .text-content_rte.common"
        )
        .forEach((ele) => {
          ele.classList.add("hidden");
        });
    }
  };
  // const loadMoreButton = document.querySelector("li#AjaxinatePagination");
  // const productGrid = document.getElementById("product-grid");
  // if (loadMoreButton && productGrid) {
  //   loadMoreButton.addEventListener("click", async () => {
  //     const collectionUrl = event.currentTarget.querySelector("a").href;
  //     //productGrid.getAttribute("data-collection-url");

  //     if (collectionUrl != null) {
  //       loadMoreButton.disabled = true;
  //       // loadMoreButton.textContent = "Loading...";

  //       try {
  //         // Fetch the next page of products
  //         const response = await fetch(
  //           `${collectionUrl}&data_id=${productGrid.getAttribute("data-id")}`
  //         );
  //         if (!response.ok) throw new Error("Failed to fetch products.");

  //         const text = await response.text();
  //         const parser = new DOMParser();
  //         const doc = parser.parseFromString(text, "text/html");

  //         const row3Products = doc.querySelector(".big-row-3");
  //         if (row3Products) {
  //           doc
  //             .querySelector("#product-grid")
  //             .appendChild(doc.querySelector(".big-row-3"));
  //         }

  //         // Extract the product grid HTML from the response
  //         const newProducts = doc.querySelector("#product-grid").children;
  //         //   doc.querySelectorAll(".collection_product_item");

  //         if (newProducts) {
  //           newProducts.forEach((product) => productGrid.appendChild(product));
  //         }

  //         if (
  //           document.querySelector('[data-filter="Größe"] li input:checked')
  //         ) {
  //           let selectedValue = document.querySelector(
  //             '[data-filter="Größe"] li input:checked'
  //           );
  //           selectedValue = value.replaceAll(" ", "");
  //           let key = "size_" + selectedValue;
  //           updateText(key);
  //         }

  //         // Update the current page
  //         //   productGrid.setAttribute("data-current-page", currentPage + 1);

  //         loadMoreButton.disabled = false;
  //         document.querySelector(".loading-img").style.display = "none";
  //       } catch (error) {
  //         document.querySelector(".loading-img").style.display = "none";
  //         loadMoreButton.disabled = false;
  //         console.error("Error loading more products:", error);
  //         loadMoreButton.disabled = false;
  //         //   loadMoreButton.textContent = "Load More";
  //       }
  //     }
  //   });
  // }


  // Attach the event listener to the document or a parent container
document.addEventListener("click", async (event) => {
  const loadMoreButton = event.target.closest("li#AjaxinatePagination");

  // If the clicked element is the load more button
  if (loadMoreButton) {
    
    event.preventDefault();
    event.stopImmediatePropagation();

    const productGrid = document.getElementById("product-grid");
    if (productGrid) {
      const collectionUrl = loadMoreButton.querySelector("a").href;
      
      if (collectionUrl != null) {
        loadMoreButton.disabled = true;
        document.querySelector(".loading-img").style.display = "block"; // Show loading image

        try {
          // Fetch the next page of products
          const response = await fetch(
            `${collectionUrl}&data_id=${productGrid.getAttribute("data-id")}`
          );
          if (!response.ok) throw new Error("Failed to fetch products.");

          const text = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");

          const row3Products = doc.querySelector(".big-row-3");
          if (row3Products) {
            productGrid.appendChild(row3Products);
          }

          // Extract and append the new products to the grid
          const newProducts = doc.querySelector("#product-grid").children;
          if (newProducts) {
            Array.from(newProducts).forEach((product) => productGrid.appendChild(product));
          }

          // Handle filter updates if necessary
          if (
            document.querySelector('[data-filter="Größe"] li input:checked')
          ) {
            let selectedValue = document.querySelector(
              '[data-filter="Größe"] li input:checked'
            ).value;
            selectedValue = selectedValue.replaceAll(" ", "");
            let key = "size_" + selectedValue;
            updateText(key);
          }

          // debugger;
          // debugger;
          loadMoreButton.disabled = false;
          document.querySelector(".loading-img").style.display = "none"; // Hide loading image
          if(doc.querySelector('.pagination-wrapper')){
            document.querySelector('.pagination-wrapper').innerHTML = doc.querySelector('.pagination-wrapper').innerHTML

            // document.querySelector('.pagination-wrapper').innerHTML = doc.querySelector('.pagination-wrapper').innerHTML;
          }
          else{
            document.querySelector('.pagination-wrapper').style.display = "none";
          }
          
        } catch (error) {
          document.querySelector(".loading-img").style.display = "none";
          loadMoreButton.disabled = false;
          console.error("Error loading more products:", error);
        }
      }
    }
  }
});
  

  document.querySelectorAll('[data-filter="Größe"] li').forEach((li) => {
    li.addEventListener("click", function (e) {
      let $this = this;
      setTimeout(() => {
        $this
          .closest("ul")
          .querySelectorAll("input:checked")
          .forEach((input) => {
            let value = input.value;
            value = value.replaceAll(" ", "");
            let key = "size_" + value;

            if (
              document.querySelector(
                "#product-grid .collection_img_with_text .text-wrap ." + key
              )
            ) {
              document
                .querySelectorAll(
                  "#product-grid .collection_img_with_text .text-wrap ." + key
                )
                .forEach((ele) => {
                  ele.classList.add("active");
                });

              document
                .querySelectorAll(
                  "#product-grid .collection_img_with_text .text-wrap .text-content_rte.common"
                )
                .forEach((ele) => {
                  ele.classList.add("hidden");
                });
            }

            // debugger;
            //   let generalText =
          });
      }, 2400);
    });
  });
  if (
    document.querySelectorAll(
      "#product-grid .collection_img_with_text .text-wrap .text-content_rte p"
    ).length > 0
  ) {
    window.filterText = [];
    document
      .querySelectorAll(
        "#product-grid .collection_img_with_text .text-wrap .text-content_rte p"
      )
      .forEach((item) => {
        let text = item.textContent;

        window.filterText.push(text);
      });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Select the "big-row-3" div
  const bigRow3 = document.querySelector(".big-row-3");

  // Select the "product-grid" div
  const productGrid = document.getElementById("product-grid");

  // Check if both elements exist
  if (bigRow3 && productGrid) {
    // Append the "big-row-3" div inside the "product-grid" div
    productGrid.appendChild(bigRow3);
    console.log("Moved .big-row-3 inside #product-grid");
  } else {
    console.warn("Element(s) not found: .big-row-3 or #product-grid");
  }
});
document.addEventListener("DOMContentLoaded", function () {
  // Function to remove the specified classes and attributes
  function removeMobileClasses() {
    document.body.classList.remove("overflow-hidden-mobile");
    // const disclosureElements = document.querySelectorAll('.mobile-facets__disclosure');
    // disclosureElements.forEach(function(el) {
    //   el.classList.remove('menu-opening');
    //   el.removeAttribute('open');
    // });
  }

  // When clicking on a facet item inside the mobile facets list
  const facetItems = document.querySelectorAll(
    ".mobile-facets__list .mobile-facets__item"
  );
  facetItems.forEach(function (item) {
    item.addEventListener("click", function (event) {
      removeMobileClasses();
      // Prevent the event from bubbling up to the document click handler
      // event.stopPropagation();
    });
  });

  if (
    document.querySelector(
      "facet-filters-form .filter_with_remove_btn .filter_menu_drawer_btn"
    )
  ) {
    document
      .querySelector(
        "facet-filters-form .filter_with_remove_btn .filter_menu_drawer_btn"
      )
      .addEventListener("click", function () {
        setTimeout(() => {
          document.body.classList.remove("overflow-hidden-mobile");
          // removeMobileClasses();
        }, 500);
      });
  }

  // When clicking anywhere on the document outside of the specified containers
  document.addEventListener("click", function (event) {
    // Check if the clicked element is NOT inside .facet-filters-form or .facets-container
    if (!event.target.closest(".facet-filters-form, .facets-container")) {
      removeMobileClasses();
    }
  });
  document.addEventListener("click", function (event) {
    const summary = event.target.closest(".mobile-facets__summary");
    if (!summary) return;

    event.stopImmediatePropagation();
    event.preventDefault();

    const details = summary.closest("details");
    const submenu = details.querySelector(".mobile-facets__submenu");

   // debugger;
    if (details.classList.contains("open")) {
      requestAnimationFrame(() => {
        submenu.style.height = "0px";
      });
      details.classList.remove("open");
    } else {
      requestAnimationFrame(() => {
        submenu.style.height = "300px";
        details.classList.add("open");
        details.setAttribute("open", "");
      });
    }
  });

  document.addEventListener("change", function (e) {
    // Check if the changed element is an input inside [data-filter] li
    if (
      e.target.matches("[data-filter] li input") ||
      e.target.closest("[data-filter] li input")
    ) {
      const input = e.target;
      const removeBtn = document.querySelector(
        '[data-remove-value="' + input.value + '"]'
      );

      if (removeBtn) {
        e.preventDefault();

        
        // debugger;
        // let details = event.target.closest('details');
        // details.classList.remove("open");
        // const submenu = event.target.closest(".mobile-facets__submenu");
        // requestAnimationFrame(() => {
        //   submenu.style.height = "0px";
        // });
       
        removeBtn.click();
        
        setTimeout(() => {
          if (document.querySelector(".loader-wrapper")) {
            document.querySelector(".loader-wrapper").classList.add("hidden");
          }

          // setTimeout(()=>{

          //   if(document.querySelector('.loader-wrapper')){
          //   document.querySelector('.loader-wrapper').classList.add('hidden');
          // }
          // }, 3000)
        }, 800);
      }
    }
  });
});
